<!-- TODO: Multilang -->
<template>
  <v-container fluid class="white data-inline-content">
    <div class="qmkey-related-inline-table">
      <v-data-table
        :headers="columns"
        :items="current_qunit[props.attr]"
        item-key="uid"
        class="qmkey-explorer-table-expansion-table"
        dense
        sort-by="version"
        must-sort
        sort-desc
      >
        <template v-slot:[`item.mimetype`]="{ item }">
          <v-icon small class="mr-2" :color="getFileIcon(item.mimetype).color">
            {{ getFileIcon(item.mimetype).icon }}
          </v-icon>
        </template>

        <!-- // this should be a QField Object -->
        <template v-slot:[`item.file_creation_date`]="{ item }">
          <span
            v-if="item.file_creation_date"          
          >
            {{
              new Date(item.file_creation_date).toLocaleDateString(undefined, {
                // weekday: 'long',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
              })
            }}
          </span>
      </template>
      <!-- // this should be a QField Object -->
      <template v-slot:[`item.modification_date`]="{ item }">
          <span
            v-if="item.modification_date"          
          >
            {{
              new Date(item.modification_date).toLocaleDateString(undefined, {
                // weekday: 'long',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
              })
            }}
          </span>
      </template>
        <!-- Actions -->      
        <template v-slot:[`item.actions`]="{ item }">
          <div class="actions-cont">
          <v-btn 
            small
            icon
            :disabled="!item.value"
            @click="handleEvidence(item)"
            color="ctas darken-2"
            >
            <v-icon small class="mr-2"> mdi-download </v-icon>
          </v-btn>
          <ActionViewReports
            :key=act
            size="small"
            :unit="item"
            loading=false,
            color="ctas darken-2"
            @refresh="refresh_qunit"
            @clicked="clicked"
          >
          </ActionViewReports>
        </div>
        </template>
      
      </v-data-table>
    </div>
  </v-container>
</template>

<style>
 .actions-cont {
   display: flex;
   gap: .2em;
   align-items: center;
   justify-content: space;
 }
</style>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import FileIcons from '@/utils/fileicons'
import ActionViewReports from '../actions/ActionViewReports.vue';
import Actions from '../actions/Actions.vue';

export default {
  name: 'InlineBoxRelatedFiles',
  components: {
    ActionViewReports,
    Actions
  },
  props: {
    current_qunit: Object,
    props: Object
  },
  data() {
    return {
      options: {
        sortBy: 'version',
      },
      selected: [],
      evidencesColumns: [
        { value: 'mimetype', text: 'Tipo', sortable: false },
        { value: 'title', text: 'Titulo', sortable: false },
        { value: 'file_creation_date', text: 'F. Creación', sortable: false },
        {
          value: 'modification_date',
          text: 'F. Modificación',
          sortable: false,
        },
        {
          value: 'version',
          text: 'Version',
          sortable: false,
        },
        { value: 'actions', text: 'Acciones', sortable: false },
      ],
      files: FileIcons,
      act: "4_something_ramdom_;p", // https://xkcd.com/221/
    }
  },
  computed: {
    columns() {
      return this.props && this.props.columns ? this.props.columns: this.evidencesColumns;
    },
  },
  watch: {
    fields_to_collect() {
      // This is to inject javascript when form is loaded
      this.$nextTick(() => {
        if (this.jsdata) {
          var jsscript = document.createElement('script')
          jsscript.innerText = this.jsdata
          document.head.appendChild(jsscript)
        }
      })
    },
  },
  methods: {
    getFileIcon(mimetype) {
      if (mimetype in this.files) {
        return this.files[mimetype];
      } else {
        return this.files['file'];
      }
    },

    handleEvidence(row){
      this.$emit('download-evidence', row)
    },    

    downloadFile(data, filename) {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([data.data], {type: 'application/vnd'})

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob)
          return
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const ob = window.URL.createObjectURL(newBlob)
      var link = document.createElement('a')
      link.href = ob
      link.download = filename //+ '.docx'
      link.click()
      setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(ob)
      }, 100)
    },

    refresh_qunit() {
      this.$emit('refresh');
    },

    update_qunit(new_qunit) {
      this.$emit('update-qunit', new_qunit);
     },

     clicked() {
      this.$emit('clicked');
     },
  }
}
</script>


<style lang="scss">
@import '@/sass/explorer.scss';
</style>
